import { render, staticRenderFns } from "./ForgotPasswordScreen.vue?vue&type=template&id=009d2598"
import script from "./ForgotPasswordScreen.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports